var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-sm-6 col"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.img,"alt":"404"}}),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Back to Home")])])
}]

export { render, staticRenderFns }